module.exports = __webpack_public_path__ + "img/our2.ac05c586.png";